<div
  class="row"
  style="align-items: flex-start; gap: 10px; padding: 10px; flex-wrap: wrap"
  [ngStyle]="getSeverityBorderStyle(notification().severity)"
  kendoTooltip
>
  <app-notification-severity-icon [severity]="notification().severity"></app-notification-severity-icon>
  <div style="display: flex; flex-direction: column; gap: 5px; flex: 1; min-width: 0">
    <div
      class="k-font-bold"
      style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 350px"
      title="{{ translatedTitle }}"
    >
      {{ translatedTitle }}
    </div>
    <div
      class="k-text-sm"
      style="text-overflow: ellipsis; overflow: hidden; max-height: 8em; width: 350px"
      title="{{ translatedText }}"
    >
      {{ translatedText }}
    </div>
    <div class="row">
      {{ notificationUserTypeMap[notification().audience] | translate }}
      @if(notification().audience !== notificationUserType.SINGLE_USER){ ({{ notification().siteName }}) } • {{ notification().eventDate | date : 'short' }}
    </div>
  </div>

  <div style="display: flex; gap: 8px; flex-wrap: wrap; align-content: flex-start">
    @if (notification().docRefGuid || notification().docRefInt) {

    <button
      kendoButton
      [fillMode]="'link'"
      [themeColor]="'primary'"
      [svgIcon]="eyeIcon"
      (click)="navigateToDocument()"
      title="{{ navigateTitle() | translate }}"
    ></button>
    } @if(actionIcon()) {
    <button
      kendoButton
      [fillMode]="'outline'"
      [themeColor]="actionThemeColor()"
      [svgIcon]="actionIcon()"
      (click)="onAction()"
      title="{{ actionTitle() | translate }}"
    ></button>

    }
  </div>
</div>
